export enum POSITIONS {
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right'
}

interface CornerProps {
  position: POSITIONS
}

const classMap: Record<POSITIONS, string> = {
  [POSITIONS.TOP_LEFT]: 'left-0 -rotate-90',
  [POSITIONS.TOP_RIGHT]: 'right-0'
}

export const Corner = ({ position }: CornerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 5 5"
    fill="none"
    className={`text-header-text absolute top-0 transform opacity-40 ${classMap[position]}`}
  >
    <path d="M4.37114e-07 -4.37114e-07C3.6 -1.22392e-07 4.83333 3.33333 5 5L5 0L4.37114e-07 -4.37114e-07Z" fill="currentColor" />
  </svg>
)
